import React, { forwardRef } from 'react';
import cn from 'classnames';
import { PaginationVariantProps } from '../types';

import IconButton from '../../Buttons/IconButton';
import Text from '../../Text';

const CarouselS = forwardRef<HTMLDivElement, PaginationVariantProps>(
  (
    {
      currentPage = 1,
      totalPages = 1,
      onPrev,
      onNext,
      dark,
      white,
      className,
      ...other
    },
    ref,
  ) => (
    <div ref={ref} className={cn('flex items-center', className)} {...other}>
      <Text
        type="label"
        color={dark ? 'base-lighter' : 'gray-dark'}
        className="flex-shrink-0 mr-32"
      >
        {`Página ${currentPage} de ${totalPages}`}
      </Text>
      <IconButton
        className="flex-shrink-0 mr-32"
        arrow="left"
        xs
        darkMode={dark}
        white={white}
        disabled={currentPage <= 1}
        onClick={onPrev}
      />
      <IconButton
        className="flex-shrink-0"
        arrow="right"
        xs
        darkMode={dark}
        white={white}
        disabled={currentPage >= totalPages}
        onClick={onNext}
      />
    </div>
  ),
);

export default CarouselS;
